import QuestionPage from '@app-studio-web/ui/pages/QuestionPage'
import { useTranslation } from 'react-i18next'
import { useSubmit } from 'react-router-dom'
import useUpdateMode from '../../hooks/useUpdateMode'
import { saveAnswer } from '../../utils/onboardingStorage'

const QUESTION_KEY = 'sleepTracking'

export default function SleepTrackingPage() {
  const submit = useSubmit()
  const { t } = useTranslation()
  const { isUpdate, postToReactNative } = useUpdateMode()

  const handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    // Get the answer value from the form
    const formData = new FormData(event.currentTarget)
    const selectedValue = formData.get('answer') as string

    if (!selectedValue) return

    const answer = {
      question_key: QUESTION_KEY,
      question: t('pages.onboarding.sleepTracking.heading', { lng: 'en' }),
      answer_key: selectedValue,
      answer: selectedValue,
    }

    if (isUpdate) {
      postToReactNative(answer)
    } else {
      saveAnswer(QUESTION_KEY, answer)
      submit(event.currentTarget)
    }
  }

  // Sleep tracking options
  const getSleepTrackingOptions = () => [
    {
      value: 'Yes, regularly',
      translationKey: 'pages.onboarding.sleepTracking.options.regularly',
      emoji: '⌚',
    },
    {
      value: 'Sometimes',
      translationKey: 'pages.onboarding.sleepTracking.options.sometimes',
      emoji: '🕒',
    },
    {
      value: 'No, not at all',
      translationKey: 'pages.onboarding.sleepTracking.options.no',
      emoji: '🙅',
    },
  ]

  // Get the options
  const options = getSleepTrackingOptions()

  // Transform options to the format expected by QuestionPage
  const buttons = options.map((option) => ({
    text: `${option.emoji} ${t(option.translationKey)}`,
    value: option.value,
  }))

  return (
    <QuestionPage
      heading={t('pages.onboarding.sleepTracking.heading')}
      buttons={buttons}
      onSubmit={handleSubmit}
      headingSize="text-3xl text-center whitespace-pre-line"
      buttonTextSize="text-xl"
      buttonBgColor="bg-white"
    />
  )
}
